import { useEffect, useRef, useState } from 'react'
import { Button, Col, Form } from 'react-bootstrap'

const EnterMobileCodeForm = ({ mobileNumber,phoneEnd, disabled, debugCode, onComplete }) => {
  const [enteredCode, setEnteredCode] = useState(debugCode || '');
  const codeInputField = useRef(null);
  const [isSubmittedCodeBlank , setIsSubmittedCodeBlank] = useState(false);

  useEffect(() => {
    if (debugCode) setEnteredCode(debugCode);
  }, [debugCode]);


  useEffect(() => {
    codeInputField.current?.focus();
  }, []);

  const onChange = (e) => {
    const newValue = e.target.value;
    setEnteredCode(newValue);
    if(newValue !== '') setIsSubmittedCodeBlank(false);
  };

  const onSubmit = () => {
    if(enteredCode === ''){
      setIsSubmittedCodeBlank(true);
      return;
    }

    onComplete(enteredCode);
  }

  return (
      <>
          <div className="mb-4">
              <p>
                  A text message with a verification code has been sent to the number ending {mobileNumber?.slice(-3) || phoneEnd || 'your phone number'}.
              </p>
              <p>Please enter the code to continue</p>
          </div>
          <Form.Row className={"mb-4"}>
              <Form.Group as={Col} controlId="validationVerificationCode" className="material material label-top mb-0">
                  <Form.Control
                      type="tel"
                      name="verificationCode"
                      value={enteredCode}
                      autoFocus
                      ref={codeInputField}
                      onKeyDown={(e) => e.key === 'Enter' && onSubmit()}
                      onChange={onChange}
                      isInvalid={isSubmittedCodeBlank}
                      autoComplete="off"
                  />
                  <Form.Label>Code</Form.Label>
                  <Form.Control.Feedback type="invalid">Code is required</Form.Control.Feedback>
              </Form.Group>
          </Form.Row>
          <div className="text-center mb-3">
              <Button variant="primary" onClick={() => onSubmit()} className="btn-wide" disabled={disabled}>
                  Verify mobile number
              </Button>
          </div>
      </>
  );
};

export default EnterMobileCodeForm;